import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Select extends Component {
  state = {
    selectValue: this.props.selectValue,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      selectValue: nextProps.selectValue,
    });
  }

  handleChange = (e) => {
    this.setState({
      selectValue: this.props.options[e.target.selectedIndex].value,
    });

    this.props.onChange(e);
    // this.props.onChange(event.target.value);
  };

  render() {
    const {
      options,
      wrapClass,
      id,
      label,
      selectClass,
      name,
    } = this.props;

    const { selectValue } = this.state;

    return (
      <div className={wrapClass}>
        <label htmlFor={id}>
          <span className="custom-select--span">{label}</span>
          <select
            className={selectClass}
            name={name || ''}
            id={id || (name || '')}
            onChange={this.handleChange}
            value={selectValue}
          >
            {options.map((i) => <option key={i.value} value={i.value}>{` ${i.label}`}</option>)}
          </select>
        </label>
      </div>
    );
  }
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  onChange: PropTypes.func,
  selectValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  selectClass: PropTypes.string,
  wrapClass: PropTypes.string,
};

Select.defaultProps = {
  id: '',
  name: '',
  label: '',
  onChange: null,
  options: [],
  selectValue: '',
  selectClass: 'form-control',
  wrapClass: '',
};

export default Select;
